import '../styles/Header.css';
import logo from '../assets/img/logo-abbvie.png';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className='site-header'>
      <Link to='/'><img src={logo} alt='Abbvie - Après-traitement'/></Link>
    </header>
  )
}

export default Header